import { useSelector } from "react-redux";
import classNames from "classnames";
import { selectMechanicType } from "../../../../../redux/auth";
import { MECHANIC_TIERS } from "../../../../../constants/mechanic";
import classes from "./MechanicTier.module.css";

const MechanicTier = () => {
  const mechanicType = useSelector(selectMechanicType);

  return (
    <span
      className={classNames(
        classes["mechanic-tier"],
        classes[`mechanic-tier--${mechanicType}`]
      )}
    >
      {MECHANIC_TIERS.get(mechanicType)}
    </span>
  );
};

export default MechanicTier;
